import React from 'react';

import { flagStyles } from '../settings';

const SvgVN = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5688px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgVN;
